.section {
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 (cream) — the form band, as in the design */
  padding: 76px 0;
  scroll-margin-top: 80px; /* clear the sticky site header when jumped to via #formulaire */
}

.inner {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 56px;
  align-items: start;
}

.info__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: clamp(32px, 4.4vw, 52px);
  line-height: 1.02;
  letter-spacing: -0.02em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 16px;
}

.eta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 26px;
}

.eta__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: var(--color-primary-blue-500); /* blue-500 */
  color: var(--color-primary-grey-000);
}

.callout {
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 16px;
  padding: 18px 22px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-primary-sand-900); /* text-2 */
  margin-bottom: 16px;
}

.calloutHelp {
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
}

.callout__lead {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 12px;
}

.callout__lead a {
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.callout__label {
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-tertiary); /* text-3 */
  margin: 0 0 10px;
}

.callout__links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.callout__links a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px; /* COPY_S */
  font-weight: 700;
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
  transition: color 0.18s cubic-bezier(0.04, 0.4, 0.5, 0.95);
}

.callout__links a:hover {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

@media (max-width: 860px) {
  .inner {
    grid-template-columns: 1fr;
    gap: 36px;
  }
}
